export default function capitalizeAll(string: string): string {
    return string.split(' ').map((el) => (el.charAt(0).toUpperCase() + el.slice(1))).join(' ');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/filters/capitalizeAll.ts